import {
  SHOW_SOURCE_SETUP,
  HIDE_SOURCE_SETUP,
  SHOW_WAREHOUSE_SETUP,
  HIDE_WAREHOUSE_SETUP
} from 'actions'

const initialState = {
  isHidden: false,
  type: null
}

export default function(state = initialState, { type }) {
  switch (type) {
    case SHOW_SOURCE_SETUP:
      return {
        isHidden: false,
        type: 'source'
      }
    case SHOW_WAREHOUSE_SETUP:
      return {
        ...state,
        isHidden: false,
        type: 'warehouse'
      }
    case HIDE_SOURCE_SETUP:
    case HIDE_WAREHOUSE_SETUP:
      return {
        ...state,
        isHidden: true,
        type: null
      }
    default:
      return state
  }
}
